<template>
  <div class="section_partners">
    <b-container>
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12"><div class="H2">{{title[language]}}</div></b-col>
      </b-row>
      <b-row>
        <b-col cols="6" sm="6" md="4" lg="2" xl="2">
          <div class="partner_item step1">
            <div class="icon"></div>
            <div class="info">
              <div class="title">1. {{step1.title[language]}}</div>
              <div class="txt">{{step1.text[language]}}</div>
            </div>
          </div>
        </b-col>
        <b-col cols="6" sm="6" md="4" lg="2" xl="2">
          <div class="partner_item step2">
            <div class="icon"></div>
            <div class="info">
              <div class="title">2. {{step2.title[language]}}</div>
              <div class="txt">{{step2.text[language]}}</div>
            </div>
          </div>
        </b-col>
        <b-col cols="6" sm="6" md="4" lg="2" xl="2">
          <div class="partner_item step3">
            <div class="icon"></div>
            <div class="info">
              <div class="title">3. {{step3.title[language]}}</div>
              <div class="txt">{{step3.text[language]}}</div>
            </div>
          </div>
        </b-col>
        <b-col cols="6" sm="6" md="4" lg="2" xl="2">
          <div class="partner_item step4">
            <div class="icon"></div>
            <div class="info">
              <div class="title">4. {{step4.title[language]}}</div>
              <div class="txt">{{step4.text[language]}}</div>
            </div>
          </div>
        </b-col>
        <b-col cols="6" sm="6" md="4" lg="2" xl="2">
          <div class="partner_item step5">
            <div class="icon"></div>
            <div class="info">
              <div class="title">5. {{step5.title[language]}}</div>
              <div class="txt">{{step5.text[language]}}</div>
            </div>
          </div>
        </b-col>
        <b-col cols="6" sm="6" md="4" lg="2" xl="2">
          <div class="partner_item step6">
            <div class="icon"></div>
            <div class="info">
              <div class="title">6. {{step6.title[language]}}</div>
              <div class="txt">{{step6.text[language]}}</div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'AppPartners',
  props: {
    language: {
      type: String,
      default: 'ru'
    }
  },
  data() {
    return {
      title: {
        ru: 'Новый рынок сбыта за 1 год!',
        en: 'New market – in ONE year!'
      },
      step1: {
        title: {
          ru: 'Оставить завяку',
          en: 'request'
        },
        text: {
          ru: '',
          en: ''
        }
      },
      step2: {
        title: {
          ru: 'Выезд на производство',
          en: 'visit the production'
        },
        text: {
          ru: '30 дней',
          en: '30 days'
        }
      },
      step3: {
        title: {
          ru: 'Согласование условий',
          en: 'agreement of conditions'
        },
        text: {
          ru: '14 дней',
          en: '14 days'
        }
      },
      step4: {
        title: {
          ru: 'Маркетинговый план',
          en: 'marketing plan'
        },
        text: {
          ru: '30 дней',
          en: '30 days'
        }
      },
      step5: {
        title: {
          ru: 'Подписание контракта',
          en: 'signing contract'
        },
        text: {
          ru: '14 дней',
          en: '14 days'
        }
      },
      step6: {
        title: {
          ru: 'Выход на рынок',
          en: 'market entry'
        },
        text: {
          ru: '9 месяцев',
          en: '9 days'
        }
      },
    };
  }
}
</script>

<style lang="scss">
  @media (min-width: 992px) and (max-width: 1199px) {

  }
  @media (min-width: 768px) and (max-width: 991px) {

  }
  @media (min-width: 576px) and (max-width: 767px) {

  }
  @media (max-width: 575px) {

  }
.section_partners{background: #e9e9e9;padding: 20px 0;}
.section_partners .partner_item{text-align: center}

.section_partners .step1 .icon::before{content: url("../assets/icon_request_green.png");}
.section_partners .step2 .icon::before{content: url("../assets/icon_plant_green.png");}
.section_partners .step3 .icon::before{content: url("../assets/icon_discussion_green.png");}
.section_partners .step4 .icon::before{content: url("../assets/icon_marketing_green.png");}
.section_partners .step5 .icon::before{content: url("../assets/icon_contract_green.png");}
.section_partners .step6 .icon::before{content: url("../assets/icon_market_green.png");}

.section_partners .partner_item .icon{
    display: inline-block;
    cursor: pointer;
    margin: 15px;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    text-align: center;
    position: relative;
    z-index: 1;
    line-height: 100px;
    border: 3px solid #2397D3;
}
.section_partners .partner_item .icon::before { 
display: inline-block;
vertical-align: middle;
line-height: 100px;
width: 65px;
height: 65px;
}
.section_partners .partner_item .info .title{
width: 100%;
font-size: 20px;
line-height: 20px;
letter-spacing: -0.65px;
font-weight: 500; 
font-family: 'Open Sans Condensed', sans-serif;}
.section_partners .partner_item .info .txt{
width: 100%;
font-size: 14px;
line-height: 18px;
letter-spacing: -0.65px; 
font-family: 'Open Sans Condensed', sans-serif;}
</style>


// WEBPACK FOOTER //
// src/views/Partners.vue